import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { IGAEADLookupService } from 'app/shared/services/igaead-lookup.service';

@Component({
    selector: 'filter-buttons-item',
    templateUrl: './filter-buttons.component.html',
    styleUrls: ['./filter-buttons.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FilterButtonComponent implements OnInit {
    @Input() curretPage;
    filterText;
    documentSymbol;
    sessionID;
    currentBody;
    mainBody
    constructor(private router: Router,
      private route: ActivatedRoute,
      private lookupService: IGAEADLookupService) {
    }

    ngOnInit(): void {
      this.documentSymbol = this.route.snapshot.queryParamMap.get('document');
      this.sessionID = this.route.snapshot.paramMap.get('sessionID');
      this.currentBody = this.route.snapshot.paramMap.get('body');
      this.mainBody = this.lookupService.mainBodyURLValue(this.router.url);
      if(this.documentSymbol){
        this.filterText = this.documentSymbol;
      }
    }

    public openPage(name: string): void {
        this.router.navigate([this.mainBody,this.currentBody,this.sessionID, name], {});
    }
    

    getDate(params){
        let date = new Date(params.MT_dateTimeScheduleStart).toLocaleDateString('en-us',{ weekday:"long", month:"long", day:"numeric", year:"numeric", hour:"numeric", minute:"numeric"});
        return `${date + " " + params.MT_body}`;
    }
    getTitle(segment){
        let title = segment.MTS_segmentTitle;
        for(let doc of segment.MTS_selectDocumentFromWorkPackage){
          let code = new RegExp(doc.DD_symbol1)
          title =  title.replace(code, `<a href="https://undocs.org/${doc.DD_symbol1}" target="_blank">${doc.DD_symbol1}</a>`)
        }
        return title;
    }

    getSymbols(documents){
        let links = [];
        if(documents){
          for(let document of documents){
            links.push(`<a hreg="https://undocs.org/${document.DD_symbol1}" target="_blank">${document.DD_symbol1}</a>`)
          }
          return links.join(',');
        }
        return '';
    }

    
}
